import React from 'react';
import { Award, Users, Target, TrendingUp } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Expert Guidance',
      description: 'Decade of experience in Coimbatore real estate market with proven track record'
    },
    {
      icon: Users,
      title: 'Client-Centric',
      description: 'Personalized service tailored to your unique needs and preferences'
    },
    {
      icon: Target,
      title: 'Market Insights',
      description: 'Deep understanding of property values, trends, and investment opportunities'
    },
    {
      icon: TrendingUp,
      title: 'Proven Results',
      description: 'Consistent success in closing deals and exceeding client expectations'
    }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="animate-slide-in-left">
            <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              About NA Realtors
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#0F1419] mb-6 playfair leading-tight">
              Your Trusted Partner in
              <span className="text-[#D4AF37]"> Real Estate Excellence</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              NA Realtors is a premier real estate and interior design firm dedicated to helping you find
              your perfect property and transforming it into your dream home. With years of experience
              in Coimbatore's dynamic property market, we've built a reputation for integrity, expertise,
              and exceptional service.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              From luxury villas to modern apartments, we offer a curated portfolio of premium properties
              across Coimbatore's most sought-after locations. Our interior design team brings your vision
              to life with innovative designs and impeccable execution.
            </p>
            <div className="flex items-center space-x-4">
              <div className="h-1 w-16 bg-[#D4AF37]"></div>
              <p className="text-[#0F1419] font-semibold playfair text-xl">Building Dreams, Creating Homes</p>
            </div>
          </div>

          {/* Right Content - Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 animate-slide-in-right">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="bg-[#D4AF37]/10 w-14 h-14 rounded-full flex items-center justify-center mb-4">
                  <feature.icon className="w-7 h-7 text-[#D4AF37]" />
                </div>
                <h3 className="text-xl font-bold text-[#0F1419] mb-3 playfair">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};